<template>
  <head>
    <meta charset="utf-8" />
    <title>Declined Clearance Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-header-card">
                <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <div class="d-flex align-items-center">
                    <div class="page-icon bg-danger-subtle me-3">
                      <i class="mdi mdi-close-circle text-danger"></i>
                    </div>
                    <div>
                      <h4 class="mb-1 fw-bold">Declined Clearance Certificates</h4>
                      <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0">
                          <li class="breadcrumb-item"><a href="#" class="text-muted">Land & Plots</a></li>
                          <li class="breadcrumb-item"><a href="#" class="text-muted">Clearance Certificates</a></li>
                          <li class="breadcrumb-item active text-danger">Declined</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <router-link :to="{name: 'clearance-dashboard'}" class="btn btn-outline-secondary">
                    <i class="mdi mdi-arrow-left me-1"></i> Back to Dashboard
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarClearance/>

          <!-- Stats Cards -->
          <div class="row g-3 mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-danger-subtle rounded-circle me-3">
                      <i class="mdi mdi-close-circle text-danger"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Total Declined</p>
                      <h4 class="mb-0 fw-bold text-danger">{{ summary.count || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-warning-subtle rounded-circle me-3">
                      <i class="mdi mdi-currency-usd-off text-warning"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Value Declined</p>
                      <h4 class="mb-0 fw-bold text-warning">KES {{ numberFormat(totalDeclinedValue) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-info-subtle rounded-circle me-3">
                      <i class="mdi mdi-calendar-remove text-info"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Today's Declined</p>
                      <h4 class="mb-0 fw-bold text-info">{{ todaysDeclined }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-secondary-subtle rounded-circle me-3">
                      <i class="mdi mdi-calendar-month text-secondary"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">This Month</p>
                      <h4 class="mb-0 fw-bold text-secondary">{{ thisMonthDeclined }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Card -->
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <!-- Card Header -->
                <div class="card-header bg-white py-3">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <div class="icon-box bg-danger text-white rounded me-3">
                        <i class="mdi mdi-close-circle"></i>
                      </div>
                      <div>
                        <h5 class="mb-0 fw-bold">Declined Certificates</h5>
                        <small class="text-muted">Certificates that were not approved</small>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap gap-2 align-items-center">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="keyword" type="text" class="form-control" placeholder="Search..." style="min-width: 180px;">
                          <i class="mdi mdi-magnify search-icon"></i>
                        </div>
                      </div>
                      <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: 140px;">
                      <span class="text-muted">to</span>
                      <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: 140px;">
                      <button @click="getClearanceCertificates" class="btn btn-outline-danger" :disabled="loading">
                        <i class="mdi mdi-filter-outline"></i>
                      </button>
                      <button @click="downloadReport" class="btn btn-danger" :disabled="certificates.length === 0">
                        <i class="mdi mdi-download me-1"></i> Export
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="bg-light">
                      <tr>
                        <th class="border-0 ps-4">#</th>
                        <th class="border-0">Bill Details</th>
                        <th class="border-0">Property</th>
                        <th class="border-0">Owner</th>
                        <th class="border-0">Location</th>
                        <th class="border-0 text-end">Amount</th>
                        <th class="border-0">Declined By</th>
                        <th class="border-0">Reason</th>
                        <th class="border-0">Date</th>
                        <th class="border-0 text-center pe-4">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in certificates" :key="index" class="certificate-row">
                        <td class="ps-4 text-muted">{{ ((currentPage - 1) * pageSize) + index + 1 }}</td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="bill-icon bg-danger-subtle text-danger rounded me-3">
                              <i class="mdi mdi-file-cancel-outline"></i>
                            </div>
                            <div>
                              <h6 class="mb-0 fw-semibold">{{ item.billNo }}</h6>
                              <span class="badge bg-light text-dark small">{{ item.feeDescription }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.customer || item.description || '-' }}</div>
                          <small class="text-muted">{{ item.category }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.names }}</div>
                          <small class="text-muted">ID: {{ item.idNo }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.subCountyName }}</div>
                          <small class="text-muted">{{ item.wardName }}</small>
                        </td>
                        <td class="text-end">
                          <div class="fw-bold text-danger">KES {{ numberFormat(item.billTotal) }}</div>
                        </td>
                        <td>
                          <div class="fw-medium small">{{ getDeclinedByName(item.approvedBy) }}</div>
                        </td>
                        <td style="max-width: 180px;">
                          <div class="reason-badge" @click="showReason(item)">
                            <i class="mdi mdi-alert-circle-outline text-danger me-1"></i>
                            <span class="text-truncate">{{ truncateText(item.declineReason, 30) }}</span>
                          </div>
                        </td>
                        <td>
                          <div class="small">{{ formatDate(item.approvedDate) }}</div>
                          <span class="badge bg-danger-subtle text-danger small">{{ formatTimeAgo(item.approvedDate) }}</span>
                        </td>
                        <td class="text-center pe-4">
                          <div class="btn-group">
                            <button @click="viewCertificate(item)" class="btn btn-sm btn-soft-info" data-bs-toggle="modal" data-bs-target="#viewCertificateModal" title="View">
                              <i class="mdi mdi-eye-outline"></i>
                            </button>
                            <button v-if="getRight('CLEARANCE APPROVE')" @click="selectForResubmit(item)" class="btn btn-sm btn-soft-success" data-bs-toggle="modal" data-bs-target="#resubmitModal" title="Resubmit">
                              <i class="mdi mdi-refresh"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading -->
                    <div class="text-center py-5" v-if="loading">
                      <div class="spinner-border text-danger mb-3"></div>
                      <h6 class="text-muted">Loading...</h6>
                    </div>

                    <!-- Empty -->
                    <div class="text-center py-5" v-if="certificates.length === 0 && !loading">
                      <div class="empty-icon mb-3"><i class="mdi mdi-file-search-outline text-muted"></i></div>
                      <h5 class="text-muted fw-bold">No Declined Certificates Found</h5>
                      <p class="text-muted">Adjust your search or date filters.</p>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white py-3" v-if="certificates.length > 0">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <span class="text-muted me-2 small">Show</span>
                      <select v-model="pageSize" class="form-select form-select-sm" style="width: 80px;">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="text-muted small me-3">{{ ((currentPage - 1) * pageSize) + 1 }}-{{ Math.min(currentPage * pageSize, summary.count) }} of {{ summary.count }}</span>
                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage"><i class="mdi mdi-chevron-left"></i></a>
                          </li>
                          <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ active: currentPage === page }">
                            <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage"><i class="mdi mdi-chevron-right"></i></a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- View Modal -->
      <div class="modal fade" id="viewCertificateModal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title text-white"><i class="mdi mdi-close-circle me-2"></i>Declined Certificate</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">
              <div class="decline-badge d-flex align-items-center p-3 rounded bg-danger-subtle mb-4">
                <div class="decline-check me-3"><i class="mdi mdi-close-circle text-danger"></i></div>
                <div class="flex-grow-1">
                  <h6 class="mb-0 text-danger fw-bold">DECLINED</h6>
                  <small class="text-muted">By {{ selectedCertificate.approvedBy }} on {{ formatDate(selectedCertificate.approvedDate) }}</small>
                </div>
                <span class="badge bg-danger">Rejected</span>
              </div>

              <div class="reason-card p-3 rounded border border-warning bg-warning-subtle mb-4">
                <h6 class="fw-bold text-warning mb-2"><i class="mdi mdi-alert-outline me-2"></i>Reason for Decline</h6>
                <p class="mb-0">{{ selectedCertificate.declineReason }}</p>
              </div>

              <div class="row g-3">
                <div class="col-md-6">
                  <div class="info-card p-3 rounded bg-light h-100">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-receipt me-2"></i>Bill Info</h6>
                    <p class="mb-2"><span class="text-muted small d-block">Bill No</span><strong>{{ selectedCertificate.billNo }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">Fee</span><strong>{{ selectedCertificate.feeDescription }}</strong></p>
                    <p class="mb-0"><span class="text-muted small d-block">Amount</span><strong class="text-danger">KES {{ numberFormat(selectedCertificate.billTotal) }}</strong></p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-card p-3 rounded bg-light h-100">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-account me-2"></i>Customer Info</h6>
                    <p class="mb-2"><span class="text-muted small d-block">Property</span><strong>{{ selectedCertificate.customer || selectedCertificate.description }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">Owner</span><strong>{{ selectedCertificate.names }}</strong></p>
                    <p class="mb-0"><span class="text-muted small d-block">ID No</span><strong>{{ selectedCertificate.idNo }}</strong></p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="info-card p-3 rounded bg-light">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-map-marker me-2"></i>Location</h6>
                    <div class="row">
                      <div class="col-md-4"><span class="text-muted small d-block">Sub-County</span><strong>{{ selectedCertificate.subCountyName }}</strong></div>
                      <div class="col-md-4"><span class="text-muted small d-block">Ward</span><strong>{{ selectedCertificate.wardName }}</strong></div>
                      <div class="col-md-4"><span class="text-muted small d-block">Declined</span><strong class="text-danger">{{ formatDate(selectedCertificate.approvedDate) }}</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
              <button v-if="getRight('CLEARANCE APPROVE')" @click="switchToResubmit" class="btn btn-success" data-bs-dismiss="modal">
                <i class="mdi mdi-refresh me-1"></i> Resubmit
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Resubmit Modal -->
      <div class="modal fade" id="resubmitModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title text-white"><i class="mdi mdi-refresh me-2"></i>Resubmit Certificate</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">
              <div class="text-center mb-4">
                <div class="resubmit-icon mb-3"><i class="mdi mdi-refresh text-success"></i></div>
                <h6 class="fw-bold">Resubmit for Approval</h6>
              </div>
              <div class="summary-box p-3 rounded bg-light mb-3">
                <div class="d-flex justify-content-between mb-2"><span class="text-muted">Bill No</span><strong>{{ selectedCertificate.billNo }}</strong></div>
                <div class="d-flex justify-content-between mb-2"><span class="text-muted">Customer</span><strong>{{ selectedCertificate.names }}</strong></div>
                <div class="d-flex justify-content-between"><span class="text-muted">Amount</span><strong>KES {{ numberFormat(selectedCertificate.billTotal) }}</strong></div>
              </div>
              <div class="alert alert-warning small mb-3">
                <i class="mdi mdi-information-outline me-1"></i><strong>Previous reason:</strong> {{ selectedCertificate.declineReason }}
              </div>
              <div class="mb-3">
                <label class="form-label fw-semibold">Notes (Optional)</label>
                <textarea v-model="resubmitNotes" class="form-control" rows="2" placeholder="Add notes..."></textarea>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button @click="resubmitCertificate" class="btn btn-success" :disabled="processing">
                <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Processing...</span>
                <span v-else><i class="mdi mdi-refresh me-1"></i>Resubmit</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reason Modal -->
      <div class="modal fade" id="reasonModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header bg-warning">
              <h5 class="modal-title"><i class="mdi mdi-alert-circle me-2"></i>Decline Reason</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedReason">
              <div class="text-center mb-3">
                <span class="badge bg-danger mb-2">{{ selectedReason.billNo }}</span>
                <h6 class="fw-bold">{{ selectedReason.names }}</h6>
              </div>
              <div class="reason-text p-3 rounded bg-light">{{ selectedReason.declineReason }}</div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer"><div class="container-fluid"><div class="row"><div class="col-sm-6"></div></div></div></footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToolBarClearance from "@/components/landrate/ToolBarClearance.vue";
import moment from "moment/moment";
import { execute, getRight, landRate } from "@/api";

export default {
  name: "DeclinedClearanceCertificates",
  components: { NavigationBar, ToolBarClearance },
  data() {
    return {
      loading: false,
      processing: false,
      keyword: '',
      dateFrom: '',
      dateTo: '',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      certificates: [],
      selectedCertificate: null,
      selectedReason: null,
      resubmitNotes: '',
      summary: { count: 0 }
    }
  },
  computed: {
    totalDeclinedValue() {
      return this.certificates.reduce((sum, cert) => sum + parseFloat(cert.billTotal || 0), 0);
    },
    todaysDeclined() {
      const today = moment().format('YYYY-MM-DD');
      return this.certificates.filter(cert => moment(cert.approvedDate).format('YYYY-MM-DD') === today).length;
    },
    thisMonthDeclined() {
      const thisMonth = moment().format('YYYY-MM');
      return this.certificates.filter(cert => moment(cert.approvedDate).format('YYYY-MM') === thisMonth).length;
    },
    visiblePages() {
      const pages = [];
      let start = Math.max(1, this.currentPage - 2);
      let end = Math.min(this.totalPages, start + 4);
      if (end - start < 4) start = Math.max(1, end - 4);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    }
  },
  watch: {
    pageSize() { this.currentPage = 1; this.getClearanceCertificates(); },
    keyword() { this.currentPage = 1; this.getClearanceCertificates(); }
  },
  mounted() {
    this.getClearanceCertificates();
  },
  methods: {
    getRight(type) { return getRight(type); },
    numberFormat(num) { return new Intl.NumberFormat("en-GB").format(num || 0); },
    formatDate(date) { return date ? moment(date).format('DD MMM YYYY HH:mm') : ''; },
    formatTimeAgo(date) { return date ? moment(date).fromNow() : ''; },
    truncateText(text, len) { return !text ? '-' : text.length > len ? text.substring(0, len) + '...' : text; },
    getDeclinedByName(by) { if (!by) return '-'; const m = by.match(/^([^(]+)/); return m ? m[1].trim() : by; },
    prevPage() { if (this.currentPage > 1) { this.currentPage--; this.getClearanceCertificates(); } },
    nextPage() { if (this.currentPage < this.totalPages) { this.currentPage++; this.getClearanceCertificates(); } },
    goToPage(page) { if (page !== this.currentPage) { this.currentPage = page; this.getClearanceCertificates(); } },

    getClearanceCertificates() {
      this.loading = true;
      this.certificates = [];
      const data = new FormData();
      data.append("function", "getClearanceCertificates");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("search", this.keyword);
      data.append("approvalStatus", "DECLINED");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data, landRate)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.certificates = res.data.data.certificates || [];
              this.summary.count = res.data.data.count?.count || 0;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            }
          })
          .catch((e) => { this.loading = false; console.error(e); });
    },

    viewCertificate(item) { this.selectedCertificate = item; },
    selectForResubmit(item) { this.selectedCertificate = item; this.resubmitNotes = ''; },
    showReason(item) { this.selectedReason = item; new bootstrap.Modal(document.getElementById('reasonModal')).show(); },
    switchToResubmit() { setTimeout(() => { new bootstrap.Modal(document.getElementById('resubmitModal')).show(); }, 300); },

    resubmitCertificate() {
      if (!this.selectedCertificate) return;
      this.processing = true;
      const data = new FormData();
      data.append("function", "resubmitClearanceCertificate");
      data.append("id", this.selectedCertificate.id);
      data.append("billNo", this.selectedCertificate.billNo);
      data.append("notes", this.resubmitNotes);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            this.processing = false;
            if (res.data.success) { alert("Certificate resubmitted!"); this.closeModal('resubmitModal'); this.getClearanceCertificates(); }
            else alert("Error: " + res.data.message);
          })
          .catch((e) => { this.processing = false; alert("Error: " + e.message); });
    },

    closeModal(id) { const m = document.getElementById(id); if (m) { const i = bootstrap.Modal.getInstance(m); if (i) i.hide(); } },

    downloadReport() {
      if (this.certificates.length === 0) return;
      const headers = ['#', 'Bill No', 'Fee', 'Property', 'Owner', 'ID No', 'Phone', 'Sub County', 'Ward', 'Amount', 'Declined By', 'Reason', 'Date'];
      const csvData = this.certificates.map((item, i) => [
        i + 1, item.billNo, item.feeDescription, item.customer || item.description, item.names, item.idNo,
        item.phoneNumber, item.subCountyName, item.wardName, item.billTotal, item.approvedBy, item.declineReason, moment(item.approvedDate).format('YYYY-MM-DD HH:mm')
      ]);
      let csv = headers.join(',') + '\n';
      csvData.forEach(row => { csv += row.map(f => `"${String(f || '').replace(/"/g, '""')}"`).join(',') + '\n'; });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Declined_Certificates_${moment().format('YYYY-MM-DD')}.csv`;
      link.click();
    }
  }
}
</script>

<style scoped>
.page-header-card { background: linear-gradient(135deg, #fdeaea 0%, #fff 100%); padding: 1.25rem; border-radius: 12px; border: 1px solid #f46a6a33; }
.page-icon { width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; border-radius: 12px; font-size: 28px; }
.mini-stat-card { border-radius: 12px; transition: all 0.3s ease; }
.mini-stat-card:hover { transform: translateY(-3px); box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important; }
.mini-stat-icon { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; font-size: 24px; }
.icon-box { width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
.bill-icon { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
.search-box { position: relative; }
.search-box .search-icon { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #adb5bd; }
.certificate-row:hover { background-color: rgba(244, 106, 106, 0.05); }
.btn-soft-info { color: #50a5f1; background-color: rgba(80, 165, 241, 0.1); border: none; }
.btn-soft-info:hover { color: #fff; background-color: #50a5f1; }
.btn-soft-success { color: #34c38f; background-color: rgba(52, 195, 143, 0.1); border: none; }
.btn-soft-success:hover { color: #fff; background-color: #34c38f; }
.bg-danger-subtle { background-color: rgba(244, 106, 106, 0.15) !important; }
.bg-warning-subtle { background-color: rgba(241, 180, 76, 0.15) !important; }
.bg-info-subtle { background-color: rgba(80, 165, 241, 0.15) !important; }
.bg-secondary-subtle { background-color: rgba(116, 120, 141, 0.15) !important; }
.empty-icon { width: 100px; height: 100px; display: flex; align-items: center; justify-content: center; margin: 0 auto; background: rgba(108, 117, 125, 0.1); border-radius: 50%; }
.empty-icon i { font-size: 50px; }
.decline-check { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; }
.decline-check i { font-size: 32px; }
.resubmit-icon { width: 80px; height: 80px; margin: 0 auto; display: flex; align-items: center; justify-content: center; background: rgba(52, 195, 143, 0.1); border-radius: 50%; }
.resubmit-icon i { font-size: 48px; }
.info-card { border: 1px solid #e9ecef; }
.reason-badge { cursor: pointer; padding: 4px 8px; background: rgba(244, 106, 106, 0.1); border-radius: 4px; font-size: 12px; display: flex; align-items: center; }
.reason-badge:hover { background: rgba(244, 106, 106, 0.2); }
.reason-card { border-left: 4px solid #f1b44c; }
.summary-box { border: 1px solid #e9ecef; }
.page-link { cursor: pointer; border-radius: 6px !important; margin: 0 2px; }
.page-item.active .page-link { background-color: #f46a6a; border-color: #f46a6a; }
</style>